import { UserDetail } from "Clients/Components/UserDetail";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";
import { useParams } from "react-router-dom";

export const ClientDetailPage: React.FunctionComponent = () => {
	const params = useParams();
	const id = Number(params.id);

	if (Number.isNaN(id)) {
		return <>V url chybí ID klienta</>;
	}

	return (
		<AuthenticatedLayout title="Detail uživatele">
			<UserDetail id={id} />
		</AuthenticatedLayout>
	);
};
